export function formatDateToISO(date) {
    if (date instanceof Date && !isNaN(date)) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
    return null;
}
export const getFirstAndLastDates = (date) => {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return [firstDayOfMonth, lastDayOfMonth];
  };



  export const getInitialDateStates = (currentDate) => {
    const year = currentDate.getFullYear();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const lastYearFirstDayOfYear = new Date(year - 1, 0, 1);
    const lastYearLastDayOfYear = new Date(year - 1, 11, 31);
  
    return {
      startDate: formatDateToISO(firstDayOfMonth),
      endDate: formatDateToISO(lastDayOfMonth),
      lastYearStartDate: formatDateToISO(lastYearFirstDayOfYear),
      lastYearEndDate: formatDateToISO(lastYearLastDayOfYear)
    };
  };